import { render, staticRenderFns } from "./RecommendedJobsList.vue?vue&type=template&id=aec64b42&"
import script from "./RecommendedJobsList.vue?vue&type=script&lang=js&"
export * from "./RecommendedJobsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports